import React, { useEffect } from 'react'
import { gsap } from 'gsap'

const FilmStrip: React.FC = () => {
	return (
		<div className='marquee'>
			<ul className='marquee__content'>
				<li>We love you Mummy Lillian!</li>
				<li>We love you Mummy Lillian!</li>
				<li>We love you Mummy Lillian!</li>
				<li>We love you Mummy Lillian!</li>
				<li>We love you Mummy Lillian!</li>
				<li>We love you Mummy Lillian!</li>
				<li>We love you Mummy Lillian!</li>
			</ul>
			{/* <!-- Mirrors the content above --> */}
			<ul className='marquee__content' aria-hidden='true'>
				<li>We love you Mummy Lillian!</li>
				<li>We love you Mummy Lillian!</li>
				<li>We love you Mummy Lillian!</li>
				<li>We love you Mummy Lillian!</li>
				<li>We love you Mummy Lillian!</li>
				<li>We love you Mummy Lillian!</li>
				<li>We love you Mummy Lillian!</li>
			</ul>
		</div>
	)
}

export default FilmStrip
